import client from './main-client';

export const fetchDealsConsultantBidsApi = (params) => client().get('/deals-consultant-bids', { params });
export const postNewDealsConsultantBid = (data) => client().post('/deals-consultant-bids', data);
export const updateDealsConsultantBidsApi = (params) => client().put(`/deals-consultant-bids/${params.id}`, params.values);
export const deleteDealsConsultantBidsApi = (params) => client().delete('/deals-consultant-bids', { params });
export const patchDealsConsultantBidsApi = (params) => client().patch(`/deals-consultant-bids/${params.id}`, params.values);
